import React from 'react'

const IndustriesModalContent = () => {
    return (
        <>
            <h3 id="homePage_offer_dialog_title" className="mt0-00 mb1-00">
                Explore Industries (<span className="red">Update Section</span>)
            </h3>
            <p className="lh-copy mt0-00 mb2-00">
                Discover industry-specific solutions designed around your sector’s workflows, constraints, and compliance needs.
            </p>
            <ul className="mt0-00 mb2-00 pl1-50 lh-copy">
                <li className="mb0-50">Use cases built for real operating environments</li>
                <li className="mb0-50">Benchmarked practices from cross-industry experience</li>
                <li className="mb0-50">Delivery models tuned for speed, quality, and risk control</li>
            </ul>
            <p className="mt0-00 mb2-00 fw6">
                Outcome: Better-fit solutions with clearer business impact.
            </p>
        </>
    )
}

export default IndustriesModalContent